//@ts-nocheck
/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { FeatureFlag } from "../FeatureFlag";

export const DisableMultipleInProgressSubmissionsCheck: FeatureFlag = {"Id":"DisableMultipleInProgressSubmissionsCheck","Label":"(Performance) Disable the check for multiple in-progress submissions ","Impact":"Normally, on starting a new submission, the system checks for an existing submission owned by the user and redirects to that if one exists instead of creating a new submission. When this is enabled, a new submission is always created without checking.","Mode":1,"ActiveOn":null,"ActiveUntil":null,"GlobalEnabled":false,"TenantEnabled":null,"UserEnabled":null,"Scope":7};
